import { NgClass } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { RouterLink } from '@angular/router';
import { FAQ } from '@banyan/commons/models/faq.model';
import { FAQService } from '@banyan/modules/faq/services/faq.service';
import { SeoMetaService } from '@banyan/modules/shared/services/seo-meta/seo-meta.service';
import { ExpansionPanelComponent } from '@banyan/modules/standalone/expansion-panel/expansion-panel.component';
import {
  ExpansionPanelMobileComponent
} from '@banyan/modules/standalone/expansion-panel-mobile/expansion-panel-mobile.component';
import { GradientComponent } from '@banyan/modules/standalone/gradient/gradient.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [
    GradientComponent,
    TranslateModule,
    RouterLink,
    NgClass,
    MatAccordion,
    ExpansionPanelComponent,
    ExpansionPanelMobileComponent,
  ],
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FAQComponent implements OnInit, OnDestroy {
  faqService = inject(FAQService);
  translateService = inject(TranslateService);
  seoMetaService = inject(SeoMetaService);
  openQuestion: FAQ = {
    id: '',
    question: '',
    answer: '',
    category: '',
  };
  currentLang = this.translateService.currentLang;
  destroy = new Subject<void>();

  constructor() {
    this.faqService.getFAQs();
  }

  ngOnInit(): void {
    this.translateService.onLangChange
      .pipe(takeUntil(this.destroy))
      .subscribe(result => {
        if (result.lang !== this.currentLang) {
          this.currentLang = result.lang;
          this.faqService.getFAQs();
        }
      });
    this.updateSeoMetaData();
  }

  updateSeoMetaData(): void {
    this.translateService
      .get('seo.faq')
      .pipe(takeUntil(this.destroy))
      .subscribe(translations => {
        this.seoMetaService.updateMetaData(
          translations.title,
          translations.description,
          translations.keywords,
        );
      });
  }

  selectCategory(id: string): void {
    this.faqService.activeCategory.set(id);
    if (this.openQuestion.category !== id) {
      this.openQuestion = {
        id: '',
        question: '',
        answer: '',
        category: '',
      };
    }
  }

  openPanel(question: FAQ): void {
    this.openQuestion = question;
  }

  ngOnDestroy(): void {
    this.destroy.complete();
    this.destroy.next();
  }
}
